export default {
  "menu": {
    "undefined": "__UNDEFINED_MENU_ITEM__",
    "Search": "Search",
    "Insights": "AI Assistant",
    "Catalog": "Data Lake",
    "Hub": "Datasets",
    "Flows": "Flows",
    "Members": "Members",
    "Connections": "Connections",
    "Monitor": "Monitor",
    "Dashboard": "Dashboards",
    "Settings": "Settings",
    "WhatsNew": "What's New",
    "home": "home",
    "Home": "Overview",
    "section": {
      "Workspace": "Workspace"
    },
    "group": {
      "DataAndModels": "Data & Models"
    },
    "role": {
      "ADMIN": "Org admin",
      "EDITOR": "Editor",
      "VIEWER": "Viewer"
    },
    "sidebar": {
      "label": "Main",
      "collapse": "Collapse sidebar",
      "expand": "Expand sidebar",
      "createWorkspace": "Create workspace",
      "createWorkspaceUsage": "Create workspace ({used} of {limit})",
      "workspaceLimitReached": "Workspace limit reached ({used} of {limit}). Contact BEEM to add more.",
      "account": "{name} · Account"
    },
    "orgSwitcher": {
      "organization": "Organization",
      "open": "Switch organization…",
      "title": "Switch organization",
      "searchLabel": "Search organizations by name or acronym",
      "placeholder": "Search by name or acronym, e.g. PET",
      "count": "{count} organizations · by acronym",
      "countFiltered": "{shown} of {count}",
      "showNames": "Show names",
      "hideNames": "Hide names",
      "current": "Current",
      "currentLabel": "{acronym}, current organization",
      "empty": "No organization matches “{query}”."
    },
    "account": {
      "settings": "Profile & Account",
      "account": "Account",
      "logout": "Log out",
      "helpAndSupport": "Help & Support",
      "giveFeedback": "Give Feedback"
    },
    "Usage": "Usage",
    "dpuUsage": "{dpuAmount} DPUs",
    "dpuLimit": "on {limit}",
    "dpuReset": "Resets in {daysLeft} days",
    "dpuError": "Unable to calculate usage.",
    "dpuSupport": "Please contact our support team"
  }
};
